export const getFormattedPercentage = (
  value: number | undefined | null,
  maximumFractionDigits = 4
): string => {
  return value !== null && value !== undefined ? `${value.toFixed(maximumFractionDigits)}%` : "-";
};
